import {StorageService} from '../../../../services/storage-service.service';
import {Component, HostListener, Input, OnDestroy, OnInit} from '@angular/core';
import {SettingsService} from '../../../../services/settings.service';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs';
import {AuthService} from '../../../../services/auth.service';
import {UserTypeEnum} from '../../../interfaces/data.interfaces';
import {UserNotificationsService} from '../../../../services/user-notifications.service';

import { ThemeService } from '../../../../services/theme.service';

@Component({
    selector: 'app-main-toolbar',
    templateUrl: './app-main-toolbar.component.html',
    styleUrls: ['./app-main-toolbar.component.scss'],
    standalone: false
})
export class AppMainToolbarComponent implements OnInit, OnDestroy {

  @Input() showModuleMenu = true;

  showModulePanel = false;

  firstName: string;
  lastName: string;



  loggedInUser: UserTypeEnum;
  userTypeEnum = UserTypeEnum;

  subscription: Subscription = new Subscription();

  notificationCount = 0;

  constructor(
    private settingsService: SettingsService,
    public translate: TranslateService,
    private auth: AuthService,
    private router: Router,
    private storageService: StorageService,
    private userNotificationsService: UserNotificationsService,
    private themeService: ThemeService,
  ) {
    this.loggedInUser = this.storageService.get('category');

    this.firstName = this.storageService.get('firstName');
    this.lastName = this.storageService.get('lastName');
  }

  @HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      this.showModulePanel = false;
    }
  }

  ngOnInit(): void {
    this.loadNotificationCount();
  }

  private async loadNotificationCount(): Promise<void> {
    try {
      const { results } = await this.userNotificationsService.fetchNotifications();
      this.notificationCount = results.length;
    } catch (error) {
      console.error('Error loading notification count:', error);
    }
  }

  goToNotifications(): void {
    this.router.navigate(['/notifications']);
  }

  logout() {
    this.auth.logout();
    return this.router.navigate(['/']);
  }

  switchLang(language: string) {
    this.settingsService.switchLang(language);
  }

  get isDarkTheme(): boolean {
    return this.themeService.isDark;
  }

  toggleTheme(): void {
    this.themeService.toggle();
  }

  toggleLanguage(): void {
    const next = (this.translate.currentLang || this.translate.getDefaultLang() || 'en') === 'en' ? 'sw' : 'en';
    this.switchLang(next);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
